import { render } from "./NewArrivals.vue?vue&type=template&id=02343ab0"
import script from "./NewArrivals.vue?vue&type=script&lang=js"
export * from "./NewArrivals.vue?vue&type=script&lang=js"

import "./NewArrivals.vue?vue&type=style&index=0&id=02343ab0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__